import { render, staticRenderFns } from "./ProductListSlider.vue?vue&type=template&id=0938e91c&scoped=true"
import script from "./ProductListSlider.vue?vue&type=script&lang=js"
export * from "./ProductListSlider.vue?vue&type=script&lang=js"
import style0 from "./ProductListSlider.vue?vue&type=style&index=0&id=0938e91c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0938e91c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0938e91c')) {
      api.createRecord('0938e91c', component.options)
    } else {
      api.reload('0938e91c', component.options)
    }
    module.hot.accept("./ProductListSlider.vue?vue&type=template&id=0938e91c&scoped=true", function () {
      api.rerender('0938e91c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/design/components/ProductListSlider.vue"
export default component.exports